export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-shrink-0 w-full max-w-md lg:max-w-lg">
            <div className="relative">
              <div className="absolute -inset-4 bg-accent-500/8 rounded-2xl blur-2xl"></div>
              <div className="relative rounded-2xl overflow-hidden border border-background-300/30">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20home%20theater%20setup%20with%20large%20screen%20displaying%20cinematic%20content%2C%20cozy%20living%20room%20atmosphere%2C%20warm%20ambient%20lighting%2C%20comfortable%20seating%2C%20premium%20entertainment%20experience%2C%20dark%20sophisticated%20interior%2C%20cinematic%20photography&width=700&height=500&seq=juzi-about-01&orientation=landscape"
                  alt="桔子影院品牌形象展示"
                  className="w-full h-auto object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-black text-foreground-50">关于桔子影院</h2>
            <p className="text-foreground-500 text-sm mt-4 leading-relaxed">
              桔子影院成立于2024年，是国内领先的高清免费在线观影平台。我们致力于为全球华语观众提供优质、流畅、免费的影视内容服务。平台汇聚超过十万部影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等多个品类。
            </p>
            <p className="text-foreground-500 text-sm mt-3 leading-relaxed">
              凭借自主研发的智能加速技术与多节点分发网络，桔子影院实现了高清画质下的零缓冲播放体验。我们坚持"即点即播、免费高清"的产品理念，持续优化技术架构与内容生态，让每一位用户都能轻松享受影院级的观影体验。
            </p>
            <div className="grid grid-cols-3 gap-4 mt-6">
              <div className="text-center p-4 rounded-xl bg-background-100 border border-background-300/30">
                <p className="text-primary-400 text-xl font-black">10万+</p>
                <p className="text-foreground-600 text-xs mt-1">影视资源</p>
              </div>
              <div className="text-center p-4 rounded-xl bg-background-100 border border-background-300/30">
                <p className="text-accent-400 text-xl font-black">5000万+</p>
                <p className="text-foreground-600 text-xs mt-1">月活用户</p>
              </div>
              <div className="text-center p-4 rounded-xl bg-background-100 border border-background-300/30">
                <p className="text-primary-400 text-xl font-black">99.9%</p>
                <p className="text-foreground-600 text-xs mt-1">服务可用率</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}